export default __webpack_public_path__ + "static/wrap-series-bg-8235763c65228d13e33355944f7fc00a.svg";